import { render, staticRenderFns } from "./DeletePartner.vue?vue&type=template&id=4e4c9fee&scoped=true&"
import script from "./DeletePartner.vue?vue&type=script&lang=js&"
export * from "./DeletePartner.vue?vue&type=script&lang=js&"
import style0 from "./DeletePartner.vue?vue&type=style&index=0&id=4e4c9fee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4c9fee",
  null
  
)

export default component.exports